import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Navbar from "react-bootstrap/lib/Navbar";
import { Link } from "react-router-dom";
import { routerActions, push } from "connected-react-router";
import { string, func, node, bool, number, shape } from "prop-types";
import classNames from "classnames";

import { selectors as sessionSelectors } from "reducers/session";
import { selectors as communicationsSelectos } from "reducers/communications";

import { resizableRoute } from "pages/_components/Resizable";
import Avatar from "pages/_components/Avatar";
import I18n from "pages/_components/I18n";
import Menu from "pages/_components/menu/Menu";
import Image from "pages/_components/Image";
import Header from "pages/_components/header/Header";
import Badge from "pages/_components/Badge";
import Button from "pages/_components/Button";
import Dropdown from "pages/_components/Dropdown";
import ViewTitle from "pages/_components/header/components/ViewTitle";
import { Helmet } from "react-helmet";
import * as utilsI18n from "util/i18n";

import { selectors as assistantSelectors } from "reducers/assistant";
import { NavbarConsumer } from "./header/NavbarProvider";
import ArrowBack from "./header/components/ArrowBack";

class Head extends Component {
    static propTypes = {
        className: string,
        // i18n head title
        title: node,
        // specify a translated text instead a i18n key
        titleText: string,
        // back link url
        backLinkTo: string,
        // back function, ignored if backLinkTo is specified
        onBack: func,
        // close link url
        closeLinkTo: string,
        // onClose function link, ignored if closeLinkTo is specified
        onClose: func,
        // link url, it links located under title
        linkTo: string,
        // I18n id of link text, it is located under title
        linkText: string,
        loggedUser: string,
        styleOther: shape({}),
        // head logo
        logo: node,
        // called right after button with closeLinkTo is clicked
        onCloseClick: func,
        hasCenterContent: bool,
        showPlusIcon: bool,
        accessibilityTextId: string,
        dispatch: func.isRequired,
        hasActiveSession: bool,
        isMobile: bool,
        isDesktop: bool,
        unreadCommunications: number,
        onAdd: func,
        addLinkTo: string,
        addLinkToLabel: string,
        exportList: string,
        handleInviteClick: func.isRequired,
        environments: string,
        activeEnvironment: string,
        note: string,
        handleClick: func.isRequired,
        isFetchingExport: bool,
        children: shape().isRequired,
        replace: string,
        hideNavbarInMobile: bool,
        updateFocus: bool, // Prop which defines if component will re render if updated or not
        autoLabelFlag: bool,
        tooltip: string,
        tooltipImage: string,
        onClickTooltip: func,
        onlyPdf: bool,
        showCenterContent: bool,
        tooltipMobile: bool,
    };

    static defaultProps = {
        className: "",
        title: null,
        titleText: "",
        backLinkTo: "",
        styleOther: {},
        onBack: null,
        closeLinkTo: "",
        onClose: null,
        linkTo: "",
        linkText: "",
        loggedUser: null,
        logo: null,
        onCloseClick: () => {},
        hasCenterContent: false,
        showPlusIcon: false,
        accessibilityTextId: "",
        hasActiveSession: false,
        isMobile: false,
        isDesktop: false,
        unreadCommunications: 0,
        onAdd: null,
        addLinkTo: "",
        addLinkToLabel: "",
        exportList: "",
        environments: "",
        activeEnvironment: "",
        note: "",
        isFetchingExport: false,
        replace: "",
        hideNavbarInMobile: false,
        updateFocus: true,
        autoLabelFlag: false,
        tooltip: "",
        tooltipMobile: false,
        tooltipImage: "",
        onClickTooltip: null,
        onlyPdf: false,
        showCenterContent: false,
    };

    constructor(props) {
        super(props);
        this.titleRef = React.createRef();
    }

    componentDidMount() {
        if (this.titleRef.current) {
            this.titleRef.current.focus({
                preventScroll: true,
            });
        }
    }

    componentDidUpdate() {
        const { updateFocus } = this.props;
        if (this.titleRef.current && updateFocus) {
            this.titleRef.current.focus({
                preventScroll: true,
            });
        }
    }

    getRightOption = () => {
        const {
            backLinkTo,
            onBack,
            closeLinkTo,
            onClose,
            loggedUser,
            hasActiveSession,
            isMobile,
            unreadCommunications,
            tooltipMobile,
            tooltipImage,
            onClickTooltip,
        } = this.props;
        if (backLinkTo || onBack) {
            // return backLinkTo ? <Back backLinkTo={backLinkTo} /> : <Back onBack={onBack} />;
            return (
                <>
                    <div className="toolbar-view-back">
                        <ArrowBack backLinkTo={backLinkTo} onClickBack={onBack} />
                    </div>
                    {tooltipMobile && (
                        <div className="right-options-mb">
                            <div className="toolbar-item message">
                                <Button
                                    className="icon-button toolbar-btn"
                                    bsStyle="link"
                                    image={tooltipImage || "images/figma/icon/info.svg"}
                                    block={false}
                                    onClick={onClickTooltip}
                                />
                            </div>
                        </div>
                    )}
                </>
            );
        }
        if (hasActiveSession && isMobile && !closeLinkTo && !onClose) {
            return (
                <div className="right-options-mb">
                    <div className="toolbar-item message">
                        <Link className="btn toolbar-btn" to="/communications">
                            <Image className="icon-large" src="images/figma/icon/bell-white.svg" />
                            <I18n id="menu.chat" />
                            {unreadCommunications > 0 && (
                                <>
                                    <Badge count={unreadCommunications} />
                                    <I18n id="menu.chat.badge" componentProps={{ className: "visually-hidden" }} />
                                </>
                            )}
                        </Link>
                    </div>
                    <Avatar user={loggedUser} linkSettings />
                </div>
            );
        }

        return null;
    };

    close = () => {
        const { onCloseClick, dispatch, closeLinkTo } = this.props;
        onCloseClick();
        dispatch(routerActions.replace({ pathname: closeLinkTo, state: { transition: "transition-flow-close" } }));
    };

    add = () => {
        const { dispatch, onAdd, addLinkTo, isDesktop } = this.props;

        if (onAdd) {
            onAdd();
        }
        let routerAction = {
            pathname: addLinkTo,
            state: { transition: "transition-flow-open" },
        };

        if (isDesktop) {
            // con la transition no está funcionando en Desktop, se quita y se sigue el issue para encontrar el motivo
            routerAction = {
                pathname: addLinkTo,
            };
        }

        dispatch(routerActions.replace(routerAction));
    };

    goToPage = (page) => {
        const { dispatch } = this.props;
        dispatch(push(page));
    };

    renderExport = () => {
        const { handleClick, isFetchingExport, onlyPdf } = this.props;
        return onlyPdf ? (
            <Button
                className="btn btn-outline"
                image="images/figma/icon/download.svg"
                label="global.download"
                onClick={() => handleClick("pdf")}
                loading={isFetchingExport}
            />
        ) : (
            <div className="toolbar-item dropdown" key="exportList">
                <Dropdown
                    image="images/figma/icon/download.svg"
                    label="global.download"
                    buttonClass="btn btn-outline"
                    fetching={isFetchingExport}
                    pullRight>
                    <Button
                        onClick={() => handleClick("pdf")}
                        label="global.download.pdf"
                        className="dropdown__item-btn"
                        bsStyle="link"
                    />
                    <Button
                        onClick={() => handleClick("xls")}
                        label="global.download.xls"
                        className="dropdown__item-btn"
                        bsStyle="link"
                    />
                </Dropdown>
            </div>
        );
    };

    getLeftOption = () => {
        const {
            addLinkTo,
            addLinkToLabel,
            closeLinkTo,
            exportList,
            handleInviteClick,
            hasActiveSession,
            isDesktop,
            isMobile,
            onAdd,
            onClose,
            showPlusIcon,
            note,
            hideNavbarInMobile,
            environments,
            activeEnvironment,
        } = this.props;

        const noteElement = (
            <div className="toolbar-item view-note">
                <span>{note}</span>
            </div>
        );

        const closeElement = (
            <div className="toolbar-item toolbar-item-close">
                <Button
                    className="toolbar-btn view-close"
                    onClick={closeLinkTo ? this.close : onClose}
                    image="images/figma/icon/cross-white.svg"
                    label="global.close"
                    bsStyle="asLink"
                />
            </div>
        );

        if (closeLinkTo || onClose || note) {
            return (
                <>
                    {note && noteElement}
                    {(closeLinkTo || onClose) && closeElement}
                </>
            );
        }

        let buttons = [];

        if (exportList) {
            buttons = [...buttons, this.renderExport()];
        }

        const addButton = (
            <div className="toolbar-item-right add-button" key="add">
                <Button
                    onClick={this.add}
                    block={false}
                    bsStyle={isDesktop ? "outline" : "asLink"}
                    className={classNames({ "btn-outline": isDesktop, "toolbar-btn view-close": !isDesktop })}>
                    <Image src="images/figma/icon/nuevo-white.svg" className="svg-icon" />
                    <I18n id={addLinkToLabel} componentProps={!isDesktop && { className: "visually-hidden" }} />
                </Button>
            </div>
        );

        if (addLinkTo || onAdd) {
            if (showPlusIcon) {
                return addButton;
            }
            buttons = [...buttons, addButton];
        }

        if (handleInviteClick) {
            buttons = [
                <div className="toolbar-item invite" key="invite">
                    <Button
                        onClick={handleInviteClick}
                        className="btn btn-small btn-outline"
                        image="images/figma/icon/nuevo.svg"
                        label="administration.users.list.addUser"
                    />
                </div>,
                ...buttons,
            ];
        }

        if (hasActiveSession && isMobile && !hideNavbarInMobile) {
            return (
                <div className="left-option-mb">
                    <div className="toolbar-item">
                        <Navbar.Toggle>
                            <NavbarConsumer>
                                {({ expanded }) => (
                                    <>
                                        <Image
                                            src={`images/figma/icon/${
                                                expanded ? "cross-white" : "hamburguesa-white"
                                            }.svg`}
                                        />
                                        <I18n id="global.menu" componentProps={{ className: "visually-hidden" }} />
                                    </>
                                )}
                            </NavbarConsumer>
                        </Navbar.Toggle>
                        <Navbar.Collapse>
                            <div className="py-2 pl-4 pr-6">
                                {environments && Object.keys(environments).length > 1 && (
                                    <Link
                                        className="change-environment-link"
                                        to={{
                                            pathname: "/settings/changeEnvironment",
                                        }}>
                                        <div className="environment-section">
                                            <Image src={`images/${activeEnvironment.type}.svg`} />
                                            <span className="data-desc">{activeEnvironment.name}</span>
                                            <Image
                                                src="images/chevromRight.svg"
                                                className="environment-section-arrow"
                                                wrapperClassName="svg-wrapper svg-wrapper-right"
                                            />
                                        </div>
                                    </Link>
                                )}
                                <Menu isMobile={isMobile} />
                            </div>
                        </Navbar.Collapse>
                    </div>
                    <Image src="images/bi-logo.svg" wrapperClassName="d-flex ml-5" />
                </div>
            );
        }

        return buttons.length ? <Fragment>{buttons}</Fragment> : null;
    };

    getCenterContent = () => {
        const {
            children,
            logo,
            replace,
            title,
            titleText,
            hasCenterContent,
            accessibilityTextId,
            autoLabelFlag,
            tooltip,
            tooltipImage,
            onClickTooltip,
        } = this.props;

        return (
            (title || titleText || logo || hasCenterContent || accessibilityTextId) && (
                <Fragment>
                    <Helmet>
                        <title>
                            {// eslint-disable-next-line no-nested-ternary
                            utilsI18n.get(accessibilityTextId || title) !== "*undefined*"
                                ? `BiBank - ${`${utilsI18n.get(accessibilityTextId || title)} ${replace.USER_NAME ||
                                      ""}`}`
                                : titleText !== ""
                                ? `BiBank - ${titleText}`
                                : "BiBank"}
                        </title>
                    </Helmet>
                    {(title || titleText) &&
                        (tooltip !== "" ? (
                            <>
                                {accessibilityTextId && (
                                    <I18n
                                        id={accessibilityTextId}
                                        component="h1"
                                        componentProps={{ className: "visually-hidden" }}
                                    />
                                )}
                                <h1 className="title-content">
                                    <I18n id={title} defaultValue={titleText} {...replace} />
                                    {/* <div className="tooltip">
                                        <Image src="images/information_fill.svg" />
                                    </div> */}
                                </h1>
                                <Button
                                    className="head__icon-button"
                                    bsStyle="link"
                                    image={tooltipImage || "images/figma/icon/info.svg"}
                                    block={false}
                                    onClick={onClickTooltip}
                                />
                                {autoLabelFlag && <span className="tag">Auto</span>}
                            </>
                        ) : (
                            <ViewTitle
                                id={title}
                                accessibilityTextId={accessibilityTextId}
                                replace={replace}
                                defaultValue={titleText}
                                // tooltip="Tooltip info"
                            />
                        ))}
                    {children}
                    {this.getCenterOption()}
                </Fragment>
            )
        );
    };

    getCenterOption = () => {
        const { linkTo, linkText } = this.props;
        if (linkTo) {
            return (
                <p>
                    <Button image="images/editPen.svg" onClick={linkTo} bsStyle="link">
                        <Image src="images/editPen.svg" className="svg-icon" />
                        <I18n id={linkText} />
                    </Button>
                </p>
            );
        }
        return null;
    };

    render() {
        const { className, styleOther, showCenterContent, isDesktop } = this.props;

        return (
            <Header
                styleOther={styleOther}
                className={className}
                addClassName={isDesktop && "onboarding-header-desktop"}>
                {!isDesktop ? (
                    <>
                        {this.getLeftOption()}
                        {showCenterContent && this.getCenterContent()}
                        {this.getRightOption()}
                    </>
                ) : (
                    <>
                        {this.getLeftOption()}
                        {this.getRightOption()}
                        {showCenterContent && this.getCenterContent()}
                    </>
                )}
            </Header>
        );
    }
}

const mapStateToProps = (state) => ({
    hasActiveSession: assistantSelectors.isAssistantLogin(state) ? false : sessionSelectors.isLoggedIn(state),
    unreadCommunications: communicationsSelectos.getUnreadCommunications(state),
    environments: sessionSelectors.getEnvironments(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    loggedUser: sessionSelectors.getUser(state),
});

export default connect(mapStateToProps)(resizableRoute(Head));
